import {
  ActionType,
  AutoTextField,
  ObjectField,
} from '../../../components/AutoForm/AutoFieldNew';

export const note: AutoTextField = {
  id: 'note',
  label: 'Please add a note:',
  type: ActionType.text,
  multiline: true,
  minRows: 2,
};

export const modelObjectField: ObjectField = {
  id: 'model',
  label: 'Mandate',
  type: ActionType.object,
  valueField: 'name',
};

export const modelTextField: AutoTextField = {
  id: 'model',
  label: 'Mandate',
  type: ActionType.text,
};
